import { Stack, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useState, useRef } from "react";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import "./CourseMasterData.css";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { getCourseMasterData } from "../Redux/THSlice";
import AddMorePopup from "./AddMorePopup";
import EditPopup from "./EditPopup";
import Button from "@mui/material/Button";
import { uploadMasterData } from "../Redux/THSlice";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { CSVLink } from "react-csv";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
  },
});
const columns = [
  { id: "sno", label: "SL.#", align: "center" },
  {
    id: "courseCode",
    label: "Course Code",

    align: "center",
  },
  {
    id: "courseName",
    label: "Course Name",

    align: "center",
  },
  {
    id: "courseHour",
    label: "Course Hours",

    align: "center",
  },
  {
    id: "SMEId",
    label: "SME Id's",

    align: "center",
  },
  {
    id: "Edit",
    label: "Edit",

    align: "center",
  },
];
function CourseMasterData() {
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  const [searchVal, setSearchVal] = useState("");

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
    setPage(0);
  };

  const courseData = useSelector((state) => state.traininghost.courseMasterData);
  const uploadStatus = useSelector((state) => state?.traininghost?.isUploaded) ?? false
  console.log('status', uploadStatus)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [islogFetchAlert, setIslogFetchAlert] = useState(false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [islogDataFetched, setlogDataIsFetched] = useState(false);
  const [severity, setSeverity] = useState('');
  const dispatch = useDispatch();
  const [openAddMore, setOpenAddMore] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [smeName, setSmeName] = useState();
  const [uniqueID, setuniqueID] = useState();
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [uploadStatusMsg, setUploadStatusMsg] = useState('')
  const { isLoaded, isDataSentSuccess, isDataSentFailure } = useSelector((state) => state.traininghost) ?? false;

  let filteredData;
  //  useEffect(() => {
  //   filteredData = courseData.filter((val, i) =>
  //    val.courseName.toLowerCase().includes(searchVal.toLowerCase())
  //   );
  //   console.log("filterwrw", filteredData);
  //  }, [courseData]);
  filteredData = courseData.filter((val, i) =>
    (val.courseName).toLocaleLowerCase().includes(searchVal.toLocaleLowerCase())
  );
  const handleEditOpen = (smeID, uniueValue) => {
    setOpenEdit(true);
    setSmeName(smeID);
    setuniqueID(uniueValue);
  };
  useEffect(() => {
    if (isFileUploaded) {
      if (isLoaded) {
        setSeverity('warning')
        setUploadStatusMsg("File uploading...Please wait!")
      } else if (isDataSentSuccess) {
        setSeverity('success')
        setUploadStatusMsg("File Uploaded Successfully.!")
      } else {
        setSeverity('error')
        setUploadStatusMsg("Error in uploading the File!")
      }
    }
  }, [isLoaded, isDataSentSuccess, isDataSentFailure])
  const headers = [
    { label: "Course Code", key: "courseCode" },
    { label: "Course Name", key: "courseName" },
    { label: "Course Hour", key: "courseHour" },
    { label: "SME Id", key: "SMEId" }
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    dispatch(getCourseMasterData());
  }, []);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const ref = useRef();
  const saveFile = (e) => {
    setFile(e.target.files[0]);
  };
  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadMasterData(formData));
    setIsFileUploaded(true)
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        <Stack sx={{ marginTop: "0px" }}>
          <Stack>
            {/* <Typography sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
       Course Master Data
      </Typography> */}
            <h3 className="upload_section_header">Course Master Data</h3>
            {/* <Typography sx={{ fontSize: "14px", marginBottom: "20px" }}>
       This section lists the courses that are offered by L&TT. You as Admin can Add new
       courses, change the SME for a particular course.
      </Typography> */}
            <p className="upload_section_para">
              This section lists the courses that are offered by L&TT. You as Admin can Add new
              courses, change the SME for a particular course.
            </p>
          </Stack>
          <div className="course-actions-header">
            <div className="training-courses-download">
              <CSVLink data={courseData} headers={headers} filename={"course-master.csv"} target="_blank" className="training-courses-download-btn">
                Download Courses Master
              </CSVLink>
            </div>
            <Stack sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <Stack spacing={2} direction={"row"} alignItems={"center"}>
                <input type="file" accept=".xlsx" ref={ref} id="file" onChange={saveFile} hidden />
                <label className="th-mainData" for="file">
                  Select File
                </label>
                <span className="th-file_caption">
                  {file.name != undefined && file.name != null ? file.name : "No File Selected"}
                </span>
                <Button
                  className={
                    loading === false
                      ? "th-upload_button_modal_active"
                      : "th-upload_button_modal_inactive"
                  }
                  onClick={handleUpload}
                  sx={{ marginTop: "10px", marginLeft: "20px" }}
                >
                  {loading === false ? "Upload" : "Cancel"}
                </Button>
                {isFileUploaded && <Alert className="file-status" severity={severity} onClose={() => setIsFileUploaded(false)}>{uploadStatusMsg}</Alert>}
              </Stack>
            </Stack>
          </div>
          <Box
            justifyContent={"center"}
            className="text-filed-box"
            display="flex"
            alignItems={"center"}
          >
            <CssTextField
              placeholder="Search for help by course name"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "30ch", align: "center" }}
              value={searchVal}
              onChange={searchFunction}
              size="small"
              margin="dense"
              InputProps={{
                endAdornment: (
                  <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </Box>
          <Paper sx={{ width: "100%", marginTop: "10px" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="courseMasterTable">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          top: 0,
                          minWidth: column.minWidth,
                          color: "#fff",
                          backgroundColor: "#550A69",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                {/* {islogFetchAlert ? (
         <Alert
          severity={islogDataFetched ? "error" : "success"}
          style={{
           maxWidth: "fit-content",
           position: "absolute",
           top: "60px",
           right: "0px",
           zIndex: "99",
           backgroundColor: islogDataFetched ? "#ff3246" : "#05f0a5",
           color: "white",
          }}
          onClose={() => {
           setIslogFetchAlert(false);
          }}
         >
          {islogDataFetched ? "Oops! Failed to fetch data.." : null}
         </Alert>
        ) : null} */}

                {loadingSpinner ? (
                  <Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                    <CircularProgress color="secondary" centered />
                  </Box>
                ) : (
                  <TableBody>
                    {filteredData != undefined &&
                      filteredData.length != 0 &&
                      filteredData
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="center" scope="row">
                              {item.sno}
                            </TableCell>
                            <TableCell align="center">{item.courseCode}</TableCell>
                            <TableCell align="center">{item.courseName}</TableCell>
                            <TableCell align="center">{item.courseHour}</TableCell>
                            <TableCell align="center">{item.SMEId}</TableCell>
                            <TableCell
                              align="center"
                              onClick={() => {
                                handleEditOpen(item.SMEId, item.uniqueVal);
                              }}
                              sx={{ cursor: "pointer" }}
                            >
                              <img
                                src="/images/Home/edit-icon.png"
                                style={{ width: "20px", height: "20px" }}
                              ></img>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              className="courseMasterTable_pagination"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={
                filteredData != undefined && filteredData.length != 0 && filteredData.length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
          <Stack sx={{ width: "100%", justifyContent: "flex-end" }}>
            <Stack
              direction={"row"}
              spacing={1}
              onClick={() => {
                setOpenAddMore(true);
              }}
              sx={{
                marginTop: "20px",
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src="/images/Home/plussign.png"
                style={{ width: "15px", height: "15px" }}
              ></img>
              <Typography sx={{ color: "#0F4CF1", fontSize: "16px", fontWeight: "600" }}>
                Add new course
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <AddMorePopup openAddMore={openAddMore} setOpenAddMore={setOpenAddMore} />
        <EditPopup
          openEdit={openEdit}
          setOpenEdit={setOpenEdit}
          smeName={smeName}
          uniqueID={uniqueID}
        ></EditPopup>
      </ThemeProvider>
    </>
  );
}

export default CourseMasterData;
